
import './App.css';
import { AddParticipant } from './Components/AddParticipant';

function App() {
  return (
    <div className="App">
      <AddParticipant />
    </div>
  );
}

export default App;
